import React from 'react';
import { Navigate, Route } from "react-router-dom";
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../services/auth';

const RequireAuth: React.FC<any> = ({ children }) => {
    const [user] = useAuthState(auth);
    if (!user) {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        return <Navigate to="/login" replace />;
    }
    return children;
}

export default RequireAuth;